export default {
  organization: {
    pages: {
      '_admin-manage-product': {
        title: 'Manage Organization',
        actions: {
          save_changes: 'Save Changes',
          new_contact: 'New contact',
        },
        labels: {
          contact_title: 'Contact information',
        },
        tabs: {
          contacts: 'Contacts (edit)',
          address: 'Direction',
          others: 'Others',
          terms: 'Terms and Conditions',
        },
      },
      'public-profile': {
        title: 'Public File',
        general: 'General Information',
        contact: 'Contact information',
        other: 'Other information',
        actions: {
          contact: 'Contact',
        },
      },
    },
    entity: {
      name: 'Name',
      tax_id: 'Tax Id',
      website: 'Website',
      address: 'Headquarters Address',
      created_at: 'Company Creation Date',
      last_year_of_billing: 'Last year of billing (Chilean pesos)',
      description: 'Company description',
      contact: {
        name: 'Name',
        email: 'E-mail',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/organization.js